@if ((dataVisible$ | async) && heeftOndernemingen) {
    <form [formGroup]="formGroup">
        <div class="row">
            <div class="col col-1">
                @if (!this.heeftSamenwerkingsverband) {
                    <p>Vermogen {{ labelNaamOndereneming }} op {{ labelBalansSlot }}</p>
                } @else {
                    <p>Aandeel in eindvermogen {{ labelNaamOndereneming }}</p>
                }
            </div>
            <div class="col-1">
            </div>
            <div class="col-2">
                <snelstart-ui-number-form-control [decimals]="0"
                                                  [disabledControl]="true"
                                                  align="right"
                                                  class="custom-input-150"
                                                  formControlName="eindVermogen"
                                                  id="eindVermogen"
                                                  prefix="€">
                </snelstart-ui-number-form-control>
            </div>
            <div class="col-3"></div>
            <div class="col-4"></div>
        </div>
        <div class="row">
            <div class="col col-1">
                @if (!this.heeftSamenwerkingsverband) {
                    <p>Vermogen {{ labelNaamOndereneming }} op {{ labelBalansOpening }}</p>
                } @else {
                    <p>Aandeel in beginvermogen {{ labelNaamOndereneming }}</p>
                }
            </div>
            <div class="col-1"></div>
            <div class="col-2">
                <snelstart-ui-number-form-control [decimals]="0"
                                                  [disabledControl]="true"
                                                  align="right"
                                                  class="custom-input-150"
                                                  formControlName="beginVermogen"
                                                  id="beginVermogen"
                                                  prefix="€">
                </snelstart-ui-number-form-control>
            </div>
            <div class="col-3"></div>
            <div class="col-4"></div>
        </div>
    </form>

    <form [formGroup]="tellingFG">
        <div class="row">
            <div class="col col-1">
                <p>Vermogensverschil</p>
            </div>
            <div class="col-2">
                <snelstart-ui-number-form-control [calculate]="calculateVerschilVermogen()"
                                                  [decimals]="0"
                                                  [disabledControl]="true"
                                                  align="right"
                                                  class="custom-input-150"
                                                  formControlName="verschilVermogen"
                                                  id="verschilVermogen"
                                                  prefix="€">
                </snelstart-ui-number-form-control>
            </div>
            <div class="col-3"></div>
            <div class="col-4"></div>
        </div>
    </form>

    <form [formGroup]="formGroup">
        <div class="row">
            <div class="col col-1">
                <p>Bij: totaal priv&eacute;onttrekkingen</p>
            </div>
            <div class="col-2">
                <snelstart-ui-number-form-control [decimals]="0"
                                                  [disabledControl]="true"
                                                  align="right"
                                                  class="custom-input-150"
                                                  formControlName="totaleOnttrekkingen"
                                                  id="totaleOnttrekkingen"
                                                  prefix="€"
                >
                </snelstart-ui-number-form-control>
            </div>
            <div class="col-3"></div>
            <div class="col-4"></div>
        </div>
        <div class="row">
            <div class="col col-1">
                <p>Af: totaal priv&eacute;stortingen</p>
            </div>
            <div class="col-2">
                <snelstart-ui-number-form-control [decimals]="0"
                                                  [disabledControl]="true"
                                                  align="right"
                                                  class="custom-input-150"
                                                  formControlName="totaleStortingen"
                                                  id="totaleStortingen"
                                                  prefix="€ -"
                >
                </snelstart-ui-number-form-control>
            </div>
            <div class="col-3"></div>
            <div class="col-4"></div>
        </div>
    </form>

    <form [formGroup]="tellingFG">
        <div class="row">
            <div class="col col-1">
                <p>Winst volgens vermogensvergelijking</p>
            </div>
            <div class="col-2">
                <snelstart-ui-number-form-control [calculate]="calculateWinstVolgensVergelijking()"
                                                  [decimals]="0"
                                                  [disabledControl]="true"
                                                  align="right"
                                                  class="custom-input-150"
                                                  formControlName="winstVolgensVergelijking"
                                                  id="winstVolgensVergelijking"
                                                  prefix="€"
                >
                </snelstart-ui-number-form-control>
            </div>
            <div class="col-3"></div>
            <div class="col-4"></div>
        </div>
    </form>

    @if (calculateVerschilWinst() === 0) {
        <form [formGroup]="formGroup" ]>
            @if ((formGroup.controls.mutatieFOR.value ?? 0) !== 0) {
                <div class="row">
                    <div class="col col-1">
                        <p>Mutatie oudedagsreserve</p>
                    </div>
                    <div class="col-2">
                        <snelstart-ui-number-form-control [decimals]="0"
                                                          [disabledControl]="true"
                                                          align="right"
                                                          class="custom-input-150"
                                                          formControlName="mutatieFOR"
                                                          id="mutatieFOR"
                                                          prefix="€"
                        >
                        </snelstart-ui-number-form-control>
                    </div>
                    <div class="col-3"></div>
                    <div class="col-4"></div>
                </div>
            }
            @if ((formGroup.controls.mutatieHIR.value ?? 0) !== 0) {
                <div class="row">
                    <div class="col col-1">
                        <p>Mutatie herinvesteringsreserve</p>
                    </div>
                    <div class="col-2">
                        <snelstart-ui-number-form-control [decimals]="0"
                                                          [disabledControl]="true"
                                                          align="right"
                                                          class="custom-input-150"
                                                          formControlName="mutatieHIR"
                                                          id="mutatieHIR"
                                                          prefix="€"
                        >
                        </snelstart-ui-number-form-control>
                    </div>
                    <div class="col-3"></div>
                    <div class="col-4"></div>
                </div>
            }
            @if ((formGroup.controls.mutatieKER.value ?? 0) !== 0) {
                <div class="row">
                    <div class="col col-1">
                        <p>Mutatie kostenegalisatiereserve</p>
                    </div>
                    <div class="col-2">
                        <snelstart-ui-number-form-control [decimals]="0"
                                                          [disabledControl]="true"
                                                          align="right"
                                                          class="custom-input-150"
                                                          formControlName="mutatieKER"
                                                          id="mutatieKER"
                                                          prefix="€"
                        >
                        </snelstart-ui-number-form-control>
                    </div>
                    <div class="col-3"></div>
                    <div class="col-4"></div>
                </div>
            }
            @if ((formGroup.controls.investeringsBijtelling.value ?? 0) !== 0) {
                <div class="row">
                    <div class="col col-1">
                        <p>Bij: investeringsbijtelling</p>
                    </div>
                    <div class="col-2">
                        <snelstart-ui-number-form-control [decimals]="0"
                                                          [disabledControl]="true"
                                                          align="right"
                                                          class="custom-input-150"
                                                          formControlName="investeringsBijtelling"
                                                          id="investeringsBijtelling"
                                                          prefix="€"
                        >
                        </snelstart-ui-number-form-control>
                    </div>
                    <div class="col-3"></div>
                    <div class="col-4"></div>
                </div>
            }
            @if ((formGroup.controls.nietAftrekbareKostenEnLasten.value ?? 0) !== 0) {
                <div class="row">
                    <div class="col col-1">
                        <p>Bij: niet/Beperkt aftrekbare kosten</p>
                    </div>
                    <div class="col-2">
                        <snelstart-ui-number-form-control [decimals]="0"
                                                          [disabledControl]="true"
                                                          align="right"
                                                          class="custom-input-150"
                                                          formControlName="nietAftrekbareKostenEnLasten"
                                                          id="nietAftrekbareKostenEnLasten"
                                                          prefix="€"
                        >
                        </snelstart-ui-number-form-control>
                    </div>
                    <div class="col-3"></div>
                    <div class="col-4"></div>
                </div>
            }
            @if ((formGroup.controls.investeringsAftrek.value ?? 0) !== 0) {
                <div class="row">
                    <div class="col col-1">
                        <p>Af: investeringsaftrek</p>
                    </div>
                    <div class="col-2">
                        <snelstart-ui-number-form-control [decimals]="0"
                                                          [disabledControl]="true"
                                                          align="right"
                                                          class="custom-input-150"
                                                          formControlName="investeringsAftrek"
                                                          id="investeringsAftrek"
                                                          prefix="€ -"
                        >
                        </snelstart-ui-number-form-control>
                    </div>
                    <div class="col-3"></div>
                    <div class="col-4"></div>
                </div>
            }
            <div class="row">
                <div class="col col-1">
                    <p><b>Winst {{ labelNaamOndereneming }}</b></p>
                </div>
                <div class="col-2">
                    <snelstart-ui-number-form-control [decimals]="0"
                                                      [disabledControl]="true"
                                                      align="right"
                                                      class="custom-input-150"
                                                      formControlName="winstPerOnderneming"
                                                      id="winstPerOnderneming"
                                                      prefix="€"
                    >
                    </snelstart-ui-number-form-control>
                </div>
                <div class="col-3"></div>
                <div class="col-4"></div>
            </div>
        </form>

    }

    @if (calculateVerschilWinst() !== 0) {
        @if (!this.heeftSamenwerkingsverband) {
            <div style="width: 75%; padding-top: 20px">
                <snelstart-ui-alert type="warning">
                    De winst volgens vermogensvergelijking
                    € {{ this.tellingFG.get('winstVolgensVergelijking')?.value | number:'1.0-0' }}
                    is niet gelijk aan de winst volgens de resultatenrekening
                    € {{ this.formGroup.get('winstVolgensResultatenRekening')?.value | number:'1.0-0' }}
                    . <br/>
                    Het verschil is
                    € {{ (this.tellingFG.get('winstVolgensVergelijking')?.value ?? 0) - (this.formGroup.get('winstVolgensResultatenRekening')?.value ?? 0) | number:'1.0-0' }}
                    .
                    Pas de priv&eacute;stortingen en/of -onttrekkingen of de resultatenrekening aan.
                </snelstart-ui-alert>
            </div>
        } @else {
            <div style="width: 75%; padding-top: 20px">
                <snelstart-ui-alert type="warning">
                    De winst volgens vermogensvergelijking
                    € {{ this.tellingFG.get('winstVolgensVergelijking')?.value | number:'1.0-0' }}
                    is niet gelijk aan het winstaandeel in het samenwerkingsverband
                    € {{ this.formGroup.get('aandeelInWinstVolgensResultatenRekening')?.value | number:'1.0-0' }}
                    . <br/>
                    Het verschil is
                    € {{ (this.tellingFG.get('winstVolgensVergelijking')?.value ?? 0) - (this.formGroup.get('aandeelInWinstVolgensResultatenRekening')?.value ?? 0) | number:'1.0-0' }}
                    .
                    Pas de priv&eacute;stortingen en/of -onttrekkingen of het winstaandeel aan.
                </snelstart-ui-alert>
            </div>
        }
    }
} @else {
    <p>Er zijn geen ondernemingen gevonden.</p>
}
